
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">About</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">CPVA</Link></li>
              <li><Link to="/membership" className="text-gray-300 hover:text-white transition-colors">Membership</Link></li>
              <li><Link to="/careers" className="text-gray-300 hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/media" className="text-gray-300 hover:text-white transition-colors">Media</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li><a href="mailto:support@cpva.ca" className="text-gray-300 hover:text-white transition-colors">Technical Support</a></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-white transition-colors">FAQ</Link></li>
              <li><a href="mailto:members@cpva.ca" className="text-gray-300 hover:text-white transition-colors">Membership</a></li>
              <li><Link to="/billing" className="text-gray-300 hover:text-white transition-colors">Billing</Link></li>
              <li><Link to="/permissions" className="text-gray-300 hover:text-white transition-colors">Permissions</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Programs & Services</h3>
            <ul className="space-y-2">
              <li><Link to="/education" className="text-gray-300 hover:text-white transition-colors">Education Hub</Link></li>
              <li><Link to="/wellness" className="text-gray-300 hover:text-white transition-colors">Wellness Academy</Link></li>
              <li><Link to="/advocacy" className="text-gray-300 hover:text-white transition-colors">Advocacy</Link></li>
              <li><Link to="/community" className="text-gray-300 hover:text-white transition-colors">Community Spotlights</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Professional Practice</h3>
            <ul className="space-y-2">
              <li><Link to="/resources" className="text-gray-300 hover:text-white transition-colors">Practice Resources</Link></li>
              <li><Link to="/news" className="text-gray-300 hover:text-white transition-colors">News & Updates</Link></li>
              <li><Link to="/conference" className="text-gray-300 hover:text-white transition-colors">Conference</Link></li>
              <li><Link to="/continuing-education" className="text-gray-300 hover:text-white transition-colors">Continuing Education</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <div className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                CPVA
              </div>
              <div className="flex space-x-4">
                <a href="https://facebook.com" className="text-gray-300 hover:text-white transition-colors">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://linkedin.com" className="text-gray-300 hover:text-white transition-colors">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a href="https://instagram.com" className="text-gray-300 hover:text-white transition-colors">
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
                <a href="https://youtube.com" className="text-gray-300 hover:text-white transition-colors">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
                <a href="https://twitter.com" className="text-gray-300 hover:text-white transition-colors">
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
              </div>
            </div>
            
            <div className="text-center md:text-right">
              <p className="text-gray-300">© 2025 CPVA. All Rights Reserved.</p>
              <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4 mt-2">
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">Privacy Policy</Link>
                <Link to="/accessibility" className="text-gray-300 hover:text-white transition-colors text-sm">Accessibility</Link>
                <a href="https://readdy.ai/?origin=logo" className="text-gray-300 hover:text-white transition-colors text-sm">Made with Readdy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
